document.querySelectorAll('.switches__switch').forEach((x) => x.addEventListener('click', () => {
  x.closest('.switches').querySelectorAll('.switches__switch').forEach((x) => {
    x.classList.remove('is-active');
  });
  x.classList.add('is-active');
}));
